import { takeLatest, put, call } from 'redux-saga/effects';
import actionTypes from 'store/auth/actionTypes';
import history from 'utils/history';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import { signUp as signUpAction } from '../actions';

export function* signUpGen(payload) {
  const { email, password, referralCode } = payload.payload;
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.SIGN_UP,
      data: {
        email,
        password,
        referral_code: referralCode,
      },
    });
    const { data } = res;
    localStorage.setItem('tempEmail', email);
    yield put(signUpAction.success(data));
    yield call(history.push, '/auth/confirm_email');
    yield call(toast.success, 'Sign up in successfully! Please check spam box');
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(signUpAction.error(e.message));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SIGN_UP, signUpGen);
}
